import React, { Component } from 'react';

class Accordion extends Component {
    render() {
        return (
            <div className="col-md-6">
                <div className="themesflat-spacer clearfix" data-desktop={0} data-mobile={0} data-smobile={35} />
                <div className="themesflat-content-box" data-margin="3px 0 0 10px" data-mobilemargin="0 0 0 0">
                    <div className="themesflat-accordions style-2 has-icon icon-left iconstyle-2 clearfix">
                        <div className="accordion-item active">
                            <h3 className="accordion-heading"><span className="inner">Do you offer custom cutting services?</span></h3>
                            <div className="accordion-content">
                                <div>Yes! We have modern CNC cutting equipment and can cut plywood, MDF boards, and other materials to your exact specifications. Our precision cutting service ensures you get the perfect sizes for your project, reducing waste and saving you time.</div>
                            </div>
                        </div>
                        <div className="accordion-item">
                            <h3 className="accordion-heading"><span className="inner">What brands of materials do you stock?</span></h3>
                            <div className="accordion-content">
                                <div>We stock premium quality materials from trusted manufacturers including Blue Triangle, Nguvu, and other reputable brands. Our selection includes various grades of plywood, MDF boards, paints from brands like Conta and Crown, and quality hardware supplies to ensure your project's success.</div>
                            </div>
                        </div>
                        <div className="accordion-item ">
                            <h3 className="accordion-heading"><span className="inner">Can I get bulk discounts for large orders?</span></h3>
                            <div className="accordion-content">
                                <div>Absolutely! We offer competitive pricing and special rates for bulk purchases. Whether you're a contractor, developer, or undertaking a large renovation project, contact our sales team at 0729926703 to discuss volume discounts and flexible payment terms.</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Accordion;